import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-swap-vertical',
  standalone: false,
  templateUrl: './icon-swap-vertical.component.html',
  styleUrl: './icon-swap-vertical.component.scss'
})
export class IconSwapVerticalComponent {
  @Input() tooltip?: string;
}
